import Clothes from "../../models/clothes/clothes.model";
import { AppDispatch } from "../store";
import * as FavoritesReducer from "./reducer";

class FavoritesActions {

    static isFavorite = (
        item: Clothes,
        favorites: Clothes[]
    ) => {
        return favorites.some(f => f.id === item.id);
    }

    static addItem = (
        item: Clothes,
        favorites: Clothes[], 
        dispatch: AppDispatch
    ) => {
        let newFavorites = [...favorites];
        let exists = newFavorites.some(f => f.id === item.id);
        if (!exists) newFavorites.push(item);
        dispatch(FavoritesReducer.setFavorites(newFavorites));
    }

    static removeItem = (
        item: Clothes,
        favorites: Clothes[], 
        dispatch: AppDispatch
    ) => {
        let newFavorites = [...favorites];
        let index = newFavorites.findIndex(f => f.id === item.id);
        newFavorites.splice(index, 1);
        dispatch(FavoritesReducer.setFavorites(newFavorites));
    }

    static removeAll = (
        dispatch: AppDispatch
    ) => {
        dispatch(FavoritesReducer.setFavorites([]));
    }

}

export default FavoritesActions;